const ActionTypes = {
  // stdDataSet: "stdDataSet",
  // regCityGets: "regCityGets",
  // regInstGets: "regInstGets",
  courseAnnouceGets: "courseAnnouceGets",
  emptyMessage: "emptyMessage",

  USER_REGISTER_REQUEST: "USER_REGISTER_REQUEST",
  USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
  USER_REGISTER_FAIL: "USER_REGISTER_FAIL",

  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAIL: "USER_LOGIN_FAIL",

  USER_LOGOUT: "USER_LOGOUT",

  ADMIN_LOGIN_REQUEST: "ADMIN_LOGIN_REQUEST",
  ADMIN_LOGIN_SUCCESS: "ADMIN_LOGIN_SUCCESS",
  ADMIN_LOGIN_FAIL: "ADMIN_LOGIN_FAIL",

  READ_ADMIN_AUTH_REQUEST: "READ_ADMIN_AUTH_REQUEST",
  READ_ADMIN_AUTH_SUCCESS: "READ_ADMIN_AUTH_SUCCESS",
  READ_ADMIN_AUTH_FAIL: "READ_ADMIN_AUTH_FAIL",
  
  READ_USER_AUTH_REQUEST: "READ_USER_AUTH_REQUEST",
  READ_USER_AUTH_SUCCESS: "READ_USER_AUTH_SUCCESS",
  READ_USER_AUTH_FAIL: "READ_USER_AUTH_FAIL",
  
  ADMIN_LOGOUT: "ADMIN_LOGOUT",

  USER_CREATE_REQUEST: "USER_CREATE_REQUEST",
  USER_CREATE_SUCCESS: "USER_CREATE_SUCCESS",
  USER_CREATE_FAIL: "USER_CREATE_FAIL",

  CLEAR_MESSAGE: "CLEAR_MESSAGE",

  USER_QUIZ_REQUEST: "USER_QUIZ_REQUEST",
  USER_QUIZ_SUCCESS: "USER_QUIZ_SUCCESS",
  USER_QUIZ_FAIL: "USER_QUIZ_FAIL",

  USER_DATA_REQUEST: "USER_DATA_REQUEST",
  USER_DATA_SUCCESS: "USER_DATA_SUCCESS",
  USER_DATA_FAIL: "USER_DATA_FAIL",

  USER_DATA_EMAIL_REQUEST: "USER_DATA_EMAIL_REQUEST",
  USER_DATA_EMAIL_SUCCESS: "USER_DATA_EMAIL_SUCCESS",
  USER_DATA_EMAIL_FAIL: "USER_DATA_EMAIL_FAIL",

  ADMIN_CREATE_QUIZZ_REQUEST: "ADMIN_CREATE_QUIZZ_REQUEST",
  ADMIN_CREATE_QUIZZ_SUCCESS: "ADMIN_CREATE_QUIZZ_SUCCESS",
  ADMIN_CREATE_QUIZZ_FAIL: "ADMIN_CREATE_QUIZZ_FAIL",

  ADD_ATTENDANCE: 'ADD_ATTENDANCE',
  ADD_ATTENDANCE_SUCCESS: "ADD_ATTENDANCE_SUCCESS",
  ADD_ATTENDANCE_ERROR: "ADD_ATTENDANCE_ERROR",

  GET_ATTENDANCE: 'GET_ATTENDANCE',
  GET_ATTENDANCE_SUCCESS: 'GET_ATTENDANCE_SUCCESS',
  GET_ATTENDANCE_ERROR: "GET_ATTENDANCE_ERROR",

  DELETE_ATTENDANCE: 'DELETE_ATTENDANCE',
  DELETE_ATTENDANCE_SUCCESS: 'DELETE_ATTENDANCE_SUCCESS',
  DELETE_ATTENDANCE_ERROR: 'DELETE_ATTENDANCE_ERROR',

  CLOSE_ATTENDANCE: 'CLOSE_ATTENDANCE_SUCCESS',
  CLOSE_ATTENDANCE_SUCCESS: 'CLOSE_ATTENDANCE_SUCCESS',
  CLOSE_ATTENDANCE_ERROR: 'CLOSE_ATTENDANCE_ERROR',

  OPEN_ATTENDANCE: 'OPEN_ATTENDANCE',
  OPEN_ATTENDANCE_AGAIN: 'OPEN_ATTENDANCE_AGAIN',
  OPEN_ATTENDANCE_ERROR: 'OPEN_ATTENDANCE_ERROR',

  UPDATE_ATTENDANCE: 'UPDATE_ATTENDANCE',
  UPDATE_ATTENDANCE_SUCCESS: 'UPDATE_ATTENDANCE_SUCCESS',
  UPDATE_ATTENDANCE_ERROR: 'UPDATE_ATTENDANCE_ERROR',

  SINGLE_ATTENDANCE: 'SINGLE_ATTENDANCE',

  ADD_ASSIGNMENT: 'ADD_ASSIGNMENT',
  ADD_ASSIGNMENT_SUCCESS: 'ADD_ASSIGNMENT_SUCCESS',
  ADD_ASSIGNMENT_ERROR: 'ADD_ASSIGNMENT_ERROR',

  STD_GET_ASSIGNMENT: 'STD_GET_ASSIGNMENT',
  STD_GET_ASSIGNMENT_SUCCESS: 'STD_GET_ASSIGNMENT_SUCCESS',
  STD_GET_ASSIGNMENT_ERROR: 'STD_GET_ASSIGNMENT_ERROR',
  GET_SINGLE_ASSIGNMENT: 'GET_SINGLE_ASSIGNMENT',
  UPDATE_STD_ASSIGNMENT:'UPDATE_STD_ASSIGNMENT',
  UPDATE_STD_ASSIGNMENT_SUCCESS:'UPDATE_STD_ASSIGNMENT_SUCCESS',
  UPDATE_STD_ASSIGNMENT_ERROR:'UPDATE_STD_ASSIGNMENT_ERROR',

  GET_ADMIN_ASSIGNMENT:'GET_ADMIN_ASSIGNMENT',
  GET_ADMIN_ASSIGNMENT_SUCCESS:'GET_ADMIN_ASSIGNMENT_SUCCESS',
  GET_ADMIN_ASSIGNMENT_ERROR:'GET_ADMIN_ASSIGNMENT_ERROR',
  GET_ADMIN_SINGLE_ASSIGNMENT:'GET_ADMIN_SINGLE_ASSIGNMENT'



};

export default ActionTypes;
